export const ArrowUp = {
    key: "ArrowUp",
    keyCode: 38
};
export const ArrowDown = {
    key: "ArrowDown",
    keyCode: 40
};
export const S = {
    key: "s",
    keyCode: 83
};
export const Space = {
    key: " ",
    keyCode: 32
};
export const Enter = {
    key: "Enter",
    keyCode: 13
};
export const Escape = {
    key: "Escape",
    keyCode: 27
};
export const Alt = {
    key: "Alt",
    keyCode: 18
};
export const Control = {
    key: "Control",
    keyCode: 17
};
export const Shift = {
    key: "Shift",
    keyCode: 16
};
const allModifiers = [Control, Alt, Shift];
//key is *almost* supported everywhere at this point, but there's still some hangouts,
//and recentish versions of mainstream browsers that don't have it, so use keyCode as a fallback
// ***key is preferable as it is more consistent across layouts, regions etc***
/**
 *
 * @param e The keyboard event to check key state on.
 * @param key The key to check if pressed.
 * @param modifiers Any modifiers that should also be pressed.
 * @returns True if the key combination was pressed, false if not. Will not match if unspecified modifiers *are* pressed (i.e. user pressing Ctrl + S would not trigger a hotkey just mapped to S).
 */
export function isPressed(e, key, ...modifiers) {
    //keyboardEvent.getModifierState is older than the separate keyboardEvent.key property, so should be supported everywhere (except for pre 2017 Safari?)
    const pressed = e.key || e.keyCode;
    return (key.key === pressed || key.keyCode === pressed) && checkModifierState(e, ...modifiers);
}
/**
 *
 * @param e the keyboard event
 * @param expectedModifiers all modifiers which are expected to be pressed
 * @returns true if the state of all modifiers matches that of expected modifiers (should be pressed if in expectedModifiers and unpressed if not)
 */
function checkModifierState(e, ...expectedModifiers) {
    //we need to check the modifiers that haven't been provided as expected as well because we don't want to allow e.g. a 'ctrl+enter' keypress to activate an 'enter' hotkey.
    //so we will construct an expected ModifierState object, and one that matches the state of the keyboard event and make sure that they match.
    const pressed = { Alt: isModifierPressed(e, Alt), Control: isModifierPressed(e, Control), Shift: isModifierPressed(e, Shift) };
    const expected = { Alt: false, Control: false, Shift: false };
    expectedModifiers.forEach((modifier) => (expected[modifier.key] = true));
    for (const modifier of allModifiers) {
        if (pressed[modifier.key] !== expected[modifier.key]) {
            return false;
        }
    }
    return true;
}
function isModifierPressed(e, modifier) {
    if (e.getModifierState && e.getModifierState(modifier.key)) {
        return true;
    }
    switch (modifier.key) {
        case "Control": {
            return e.ctrlKey;
        }
        case "Alt": {
            return e.altKey;
        }
        case "Shift": {
            return e.shiftKey;
        }
    }
}
